import { observable, action, makeObservable } from 'mobx';
import _ from 'lodash';
import AssignmentStore from './AssignmentStore';

export default class FormStore {
  constructor(parentStore) {
    this.parentStore = parentStore;
    this.data = {};
    this.error = {};
    this.errors = [];

    makeObservable(this, {
      parentStore: observable,
      data: observable,
      error: observable,
      errors: observable,
      handlerInput: action,
      handlerTextarea: action,
      handlerCheckbox: action,
      handlerCheckboxes: action,
      handlerRating: action,
      handlerReactSelect: action,
      handlerDateInput: action,
      handlerTimestamp: action,
    });
  }

  handlerInput = (event) => {
    if (event.target?.name && event.target.checked) {
      _.set(this.data, event.target.name, event.target.checked);
    } else if (event.target?.name && event.target.value !== undefined) {
      const v = event.target.name.endsWith('variants') ? event.target.value.split(',') : event.target.value;
      _.set(this.data, event.target.name, v);
    }
  };

  handlerTextarea = (event) => {
    if (event.target?.name && event.target.value !== undefined) {
      const v = event.target.name.endsWith('variants') ? event.target.value.split(',') : event.target.value;
      _.set(this.data, event.target.name, v);
    }
  };

  handlerCheckbox = (event) => {
    _.set(this.data, event.target.name, event.target.checked);
  };

  handlerCheckboxes = (event) => {
    const currentValue = this.getField(event.target.name, []);
    if (event.target.checked === true && !currentValue.includes(event.target.value)) {
      currentValue.push(event.target.value);
      _.set(this.data, event.target.name, currentValue);
    } else if (event.target.checked === false && currentValue.includes(event.target.value)) {
      _.remove(currentValue, (str) => {
        return str === event.target.value;
      });

      _.set(this.data, event.target.name, currentValue);
    }
  };

  handlerRating = (name) => (value) => {
    _.set(this.data, name, value);
  };

  handlerReactSelect = (name) => (option) => {
    this.data[name] = option.value;
  };

  handlerDateInput = (name) => (date) => {
    this.data[name] = date;
  };

  handlerTimestamp = (name) => (date) => {
    if (date) {
      this.data[name] = date.getTime();
    }
  };

  getField(name, defaultValue) {
    return _.get(this.data, name, defaultValue);
  }

  arrayContains(name, value) {
    return _.get(this.data, name, []).includes(value);
  }

  setField(name, defaultValue) {
    return _.set(this.data, name, defaultValue);
  }

  addError(error) {
    this.errors = [error];
  }

  getErrors() {
    return this.errors;
  }
}
